export default "__VITE_ASSET__CYgbRZuD__"